import React, { useState, useEffect } from 'react';
import './logincontent.css';
import ForgotPassword from '../ForgotPassword/forgotpassword';
import { setLoginId, setToken, setUsername } from '../AuthSvc/authservice';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

const LoginContent = ({ loginstate, setLoginState }) => {
  const navigate = useNavigate();

  const [profileimage, setprofileImage] = useState([]);
  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
    ErrorMessage: '',
  });

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        const responseData = await response.json();
        const { token, userId, image, username} = responseData;
        setToken(token);
        setLoginState({ isLoggedIn: true, loginId: userId });
        setLoginId(userId);
        setUsername(username);
        setprofileImage(image);

        console.log('Login successful');

        // Wait for 5 seconds before redirecting to home page
        setTimeout(() => {
          navigate('/');
          window.location.reload();

        }, 2000);


      } else {
        const errorData = await response.json();
        console.error('Login failed:', errorData);

        if (response.status === 404) {
          setLoginData({ ...loginData, ErrorMessage: errorData.message || 'User not found' });
        } else if (response.status === 401) {
          setLoginData({ ...loginData, ErrorMessage: errorData.message || 'Invalid password' });
        } else {
          setLoginData({ ...loginData, ErrorMessage: 'Unexpected error. Please try again.' });
        }

        setLoginState({ isLoggedIn: false });
      }
    } catch (error) {
      console.error('Error during login:', error);
      setLoginState({ isLoggedIn: false });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLoginData({
      ...loginData,
      [name]: value,
    });
  };

  const [isPopupOpen, setisPopupOpen] = useState(false);

  const openPopup = () => {
    setisPopupOpen(true);
  };

  const closePopup = () => {
    setisPopupOpen(false);
  };

  return (
    <div className="loginbody">
      {loginstate.isLoggedIn ? (
        <div className="loginedcontainer">
          {/* <div className='userimg-div'>
            {profileimage != null ? (
              <img src={profileimage} alt="UIDesign" className='user-profileimg' />
            ) : (
              <img src={defaultimg} alt="UIDesign" className='user-profileimg' />
            )}
          </div> */}
          <div className="loginedtitle">
            <h2 style={{ fontWeight: '400', textAlign: 'center' }}>Welcome back !<span style={{ color: "#09CE78", display: 'block' }}>{loginData.username}</span></h2>
            <h2 style={{ fontWeight: '400', textAlign: 'center' }}>Redirecting to home page...</h2>

          </div >
        </div >
      ) : (
        <div className="logincontainer">
          <div className="logintitle">
            <h2 style={{ fontWeight: '400', textAlign: 'center' }}>Welcome back !</h2>
            <p style={{ fontSize: 'small', fontWeight: '350', marginTop: '0.5rem', marginBottom: '0.5rem', textAlign: 'center' }}>Sign in to access your profile.</p>
          </div >

          <form className='loginform' style={{ marginBottom: '0.3rem' }} onSubmit={handleLogin}>
            <input type='text' name="username" className='loginforminput' placeholder='Username' onChange={handleInputChange} value={loginData.username} required />
            <input type='password' name="password" className='loginforminput' placeholder='Password' onChange={handleInputChange} value={loginData.password} required />
            <span style={{ color: 'red', fontWeight: '390', fontSize: '0.9rem' }}>{loginData.ErrorMessage}</span>
            <input type='submit' className='loginforminput loginsubmit' value='Log In' />
          </form>

          <p style={{ textAlign: 'center' }}><a href="#forgotpassword" className='loginlinks' onClick={openPopup}>Forgot your password ?</a></p>
          {isPopupOpen && <ForgotPassword onClose={closePopup} />}

          <div style={{ marginTop: '2rem' }} className='noaccount'>
            <hr />
            <center><span style={{ display: 'inline-block', margin: '0.3rem', textAlign: 'center' }}>Don't have an account ?
              <a href='/signup' className='loginlinks' style={{ marginLeft: '0.3rem' }}> Sign up</a></span></center>
            <hr />
          </div>
          <hr />
        </div >
      )}
    </div >
  );
};

export default LoginContent
